import { API } from "@/lib/api";

export default function Avatar({ user, size = "md" }) {
  const sizeClasses = {
    sm: "h-8 w-8 text-xs",
    md: "h-10 w-10 text-sm",
    lg: "h-16 w-16 text-xl",
    xl: "h-24 w-24 text-3xl",
  };

  const getInitials = (name) => {
    if (!name) return "?";
    // Remove content in parentheses (like "(Admin)")
    const cleanName = name.replace(/\([^)]*\)/g, "").trim();
    const parts = cleanName.split(" ").filter(p => p.length > 0);
    if (parts.length >= 2) {
      return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    }
    return cleanName.substring(0, 2).toUpperCase();
  };

  const initials = getInitials(user?.name || user?.email || "User");

  if (user?.profile_photo_url) {
    const photoUrl = user.profile_photo_url.startsWith("http") 
      ? user.profile_photo_url 
      : `${API}${user.profile_photo_url}`;

    return (
      <div className={`${sizeClasses[size]} relative overflow-hidden rounded-full bg-stone-200`}>
        <img
          src={photoUrl}
          alt={user.name || "Profile"}
          className="h-full w-full object-cover"
          onError={(e) => {
            // Fallback to initials if image fails to load
            e.target.style.display = "none";
            e.target.nextSibling.style.display = "flex";
          }}
        />
        <div
          className={`${sizeClasses[size]} absolute inset-0 hidden items-center justify-center bg-gradient-to-br from-[#8B7D6B] to-[#6B5D4B] font-medium text-white`}
          style={{ display: "none" }}
        >
          {initials}
        </div>
      </div>
    );
  }

  return (
    <div
      className={`${sizeClasses[size]} flex items-center justify-center rounded-full bg-gradient-to-br from-[#8B7D6B] to-[#6B5D4B] font-medium text-white`}
    >
      {initials}
    </div>
  );
}
